routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {
    $stateProvider
        .state('home.procedureList', {
            url: "procedure-list",
            template: `<procedure-list sh-ctrl="shCtrl"></procedure-list>`
        })
        .state('home.procedureListSlug', {
            url: "product-list-slug/{procedureSlug}",
            template: `<procedure-list sh-ctrl="shCtrl"></procedure-list>`
        });

}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/procedure-list/procedure-list.config.js
 **/